import React from 'react';
import { LightgalleryProvider } from 'react-lightgallery';
import 'lightgallery.js/dist/css/lightgallery.css';

const LIGHTBOX_OPTIONS = {
  thumbnail: true,
  thumbContHeight: 100,
  thumbMargin: 16,
  getCaptionFromTitleOrAlt: false,
  zoom: false,
  actualSize: false,
  fullScreen: false,
  autoplay: false,
  download: false,
  showThumbByDefault: true,
  share: true,
  facebook: true,
  twitter: true,
  pinterest: true,
  googlePlus: false,
};

const PLUGINS = ['lg-share.js', 'lg-thumbnail.js'];

const LightboxProvider = ({ children }) => {
  return (
    <LightgalleryProvider
      lightgallerySettings={LIGHTBOX_OPTIONS}
      portalElementSelector="body"
      plugins={PLUGINS}
    >
      {children}
    </LightgalleryProvider>
  );
};

export default LightboxProvider;
